import PropTypes from 'prop-types';
import { Component } from 'react';
import Translations from '../../utils/Translations';
import Flux from '../../flux/Flux';
import '../../../../src/VX/Asset/Less/VX/07-components/base/surveys.less';
import ModalBoxModal from '../ModalBox/ModalBoxWrapper/Components/ModalBoxModal.js';
import ModalBoxHeader from '../ModalBox/ModalBoxWrapper/Components/Header/ModalBoxHeader.js';
import ModalBoxSpacer from '../ModalBox/ModalBoxWrapper/Components/ModalBoxSpacer.js';
import ModalBoxWrapper from '../ModalBox/ModalBoxWrapper/ModalBoxWrapper.js';
import style from './ModalBoxSurveyFeedback.module.less';
import withMobileViewChange from '../HigherOrderComponents/Utility/withMobileViewChange.js';
import { COLOR_TYPE_CALL_TO_ACTION, COLOR_TYPE_DISABLED } from '../SimpleElements/VXButton/ButtonHelper.js';
import { VXButtonLineConfig } from '../SimpleElements/VXButton/VXButtonConfig.js';
import VXButton from '../SimpleElements/VXButton/VXButton.js';

const draftJsMaxLength = 1200;

let timeLimitTimeout = null;

class SurveyFeedback extends Component {
	static validateEmail(email) {
		const re = Flux.Constants.RegExp.EMAIL;
		return re.test(email);
	}

	constructor(props) {
		super(props);

		this.state = {
			sending: false,
			surveyStored: false,
			timeLimit: false,
			emailValidationError: false,
			contentValidationError: false,
			feedbackValue: '',
			emailValue: Flux.Guest.getEmailAddress() || '',
		};

		this.onSurveyDataChange = this.onSurveyDataChange.bind(this);
		this.storeSurvey = this.storeSurvey.bind(this);
		this.timeLimitCallback = this.timeLimitCallback.bind(this);
		this.onFeedbackValueChange = this.onFeedbackValueChange.bind(this);
		this.onEmailValueChange = this.onEmailValueChange.bind(this);
	}

	componentDidMount() {
		Flux.Survey.addSurveyChangeListener(this.onSurveyDataChange);

		if (Flux.Survey.getSurveyData(Flux.Constants.SurveyTypes.FEEDBACK) === null) {
			Flux.Survey.loadFeedbackData();
		}
	}

	componentWillUnmount() {
		Flux.Survey.removeSurveyChangeListener(this.onSurveyDataChange);

		if (timeLimitTimeout) {
			clearTimeout(timeLimitTimeout);
		}
	}

	onFeedbackValueChange(e) {
		const value = e.target.value;
		if (value !== this.state.feedbackValue && value.length <= draftJsMaxLength) {
			this.setState({
				feedbackValue: value,
				contentValidationError: false,
			});
		}
	}

	onEmailValueChange(e) {
		const value = e.target.value;
		if (value !== this.state.emailValue) {
			this.setState({
				emailValue: value,
				emailValidationError: false,
			});
		}
	}

	onSurveyDataChange(type) {
		if (type === Flux.Constants.SurveyTypes.FEEDBACK) {
			const surveyData = Flux.Survey.getSurveyData(Flux.Constants.SurveyTypes.FEEDBACK);
			if (typeof surveyData.stored !== 'undefined' && surveyData.stored) {
				Flux.Notification.addFakeFloatingNotification(
					Translations.get('notifications.feedback_sent_subject'),
					Translations.get('notifications.feedback_sent_text'),
					'/assets/img/notifications/chatlist-full.svg',
				);
				this.props.onClose();

				this.setState({
					sending: false,
					surveyStored: surveyData.stored,
				});
			} else if (typeof surveyData.timeLimit !== 'undefined' && surveyData.timeLimit) {
				timeLimitTimeout = setTimeout(this.timeLimitCallback, 5000);

				this.setState({
					sending: false,
					timeLimit: surveyData.timeLimit,
				});
			}
		}
	}

	storeSurvey() {
		if (!this.state.sending && !this.state.surveyStored && !this.state.timeLimit) {
			const feedback = this.state.feedbackValue;
			const email = this.state.emailValue;
			const isEmailValid = SurveyFeedback.validateEmail(email) || email === '';
			const contentValid = feedback.length > 0 && feedback.length <= draftJsMaxLength;

			if (contentValid && isEmailValid) {
				Flux.Survey.storeFeedbackAnswer(this.props.isMobileView, feedback, email);
				this.setState({
					sending: true,
				});
			} else {
				this.setState({
					contentValidationError: !contentValid,
					emailValidationError: !isEmailValid,
				});
			}
		}
	}

	timeLimitCallback() {
		this.setState({
			timeLimit: false,
		});
	}

	render() {
		const config = {
			onClose: () => this.props.onClose && this.props.onClose(),
			isMobile: this.props.isMobileView,
			variableHeight: true,
			showCloseBar: false,
			forceNoPaddingTop: true,
			maxWidth: 600,
			pages: [
				<ModalBoxModal>
					<ModalBoxHeader>
						<div className={style.surveyLogo}>
							<img
								alt="Logo"
								className={style.surveyLogoImg}
								src={Flux.Browser.isSexole() ? '/assets/img/sexole/sexole_x_visit-x_logo.svg' : '/assets/img/logo.svg'}
							/>
						</div>
						<div className={style.surveyHeadlineLine1}>
							{Translations.get(this.props.isMobileView ? 'SurveyFeedbackHeadlineMobile' : 'SurveyFeedbackHeadline')}
						</div>
						<div className={style.surveyHeadlineLine2}>
							{Translations.get(this.props.isMobileView ? 'SurveyFeedbackHeadlineBigMobile' : 'SurveyFeedbackHeadlineBig')}
						</div>
					</ModalBoxHeader>
					<ModalBoxSpacer />
					<label>
						<span className={style.surveyLabel}>{Translations.get('SurveyFeedbackInputLabel')}</span>
						<textarea
							onChange={this.onFeedbackValueChange}
							value={this.state.feedbackValue}
							className={style.surveyInput + (this.state.contentValidationError ? ' ' + style.surveyInputError : '')}
							rows={4}
							placeholder={Translations.get('SurveyFeedbackInputPlaceholder')}
						></textarea>
						<div className={style.surveyInputInfo + (this.state.contentValidationError ? ' ' + style.surveyInputInfoError : '')}>
							<div className={style.surveyInputInfoErrorField}>
								{this.state.contentValidationError && Translations.get('SurveyFeedbackInputValidationError')}
							</div>
							<div className={style.surveyInputInfoCount}>
								{this.state.feedbackValue.length} / {draftJsMaxLength}
							</div>
						</div>
					</label>
					<ModalBoxSpacer />
					<label>
						<span className={style.surveyLabel}>{Translations.get('SurveyFeedbackEmailInputLabel')}</span>
						<input
							onChange={this.onEmailValueChange}
							value={this.state.emailValue}
							className={style.surveyInputEmail + (this.state.emailValidationError ? ' ' + style.surveyInputEmailError : '')}
							type={'email'}
							placeholder={'beispiel@mail.com'}
						/>
						<div className={style.surveyInputInfo + (this.state.emailValidationError ? ' ' + style.surveyInputInfoError : '')}>
							<div className={style.surveyInputInfoErrorField}>
								{this.state.emailValidationError && Translations.get('SurveyFeedbackEmailValidationError')}
							</div>
						</div>
					</label>
					<div className={style.surveySubmitButton}>
						<VXButton
							color={
								this.state.emailValidationError || this.state.timeLimit || this.state.contentValidationError
									? COLOR_TYPE_DISABLED
									: COLOR_TYPE_CALL_TO_ACTION
							}
							line1={[
								new VXButtonLineConfig(Translations.get(this.state.timeLimit ? 'PleaseTryAgainLater' : 'SurveyFeedbackSendFeedback')),
							]}
							onClick={this.storeSurvey}
							staticMode={true}
						/>
					</div>
				</ModalBoxModal>,
			],
		};

		return <ModalBoxWrapper {...config} />;
	}
}

SurveyFeedback.propTypes = {
	isMobileView: PropTypes.bool,
	onClose: PropTypes.func,
};

SurveyFeedback.defaultProps = {
	isMobileView: false,
	onClose: () => {
		/* no-op */
	},
};

export default withMobileViewChange(SurveyFeedback);
